import { BlueprintEditorToolCircleIcon } from '@editor/assets/icons'
import { ProductTypes } from '@editor/config/constants'
import { DrawingType } from '@editor/interfaces/drawing'
import { UserInfo } from '@editor/interfaces/interfaces'
import { BLUEPRINT_TOOL_LABELS } from '@editor/pages/projects/blueprint-editor/constants'

import { BlueprintEditorTool, BlueprintEditorTools, BlueprintToolbarCategory, Mode } from '../../../definitions'
import useDrawingsPanel from './hooks/useDrawingsPanel'
import useEditor from './hooks/useEditor'
import useMainCanvas from './hooks/useMainCanvas'

const Circle: BlueprintEditorTool = {
  key: BlueprintEditorTools.Circle,
  drawingType: DrawingType.Circle,
  authCheck: (userProfile: UserInfo | null, isAllowedToModify: boolean) =>
    (userProfile?.owned_products.includes(ProductTypes.Markly) && isAllowedToModify) || false,
  toolbar: {
    icon: <BlueprintEditorToolCircleIcon width="50%" height="50%" />,
    label: BLUEPRINT_TOOL_LABELS[BlueprintEditorTools.Circle],
    category: BlueprintToolbarCategory.Draw,
    modes: [Mode.Editor2D],
  },
  hooks: {
    useEditor,
    useMainCanvas,
    useDrawingsPanel,
  },
  config: {
    switchToDrawingPanelOnActive: true,
    anchor: {
      notPlaceableOnObjects: true,
      useSolidMesh: true,
    },
  },
}

export default Circle
